import { createSlice } from "@reduxjs/toolkit";

type InitialState = {
  language: String;
};

const initialState: InitialState = {
  language: "",
};

const language = createSlice({
  name: "language",
  initialState: initialState,
  reducers: {
    setLanguage: (state, action) => {
      state.language = action.payload;
    },
  },
});

export const languageActions = language.actions;
export default language.reducer;
